const INTEGRATION_LOGOS = {
  quickbooks: {
    src: "/integrations/quickbooks.svg",
    alt: "QuickBooks",
  },
  xero: {
    src: "/integrations/xero.svg",
    alt: "Xero",
  },
  priority: {
    src: "/integrations/priority-icon.svg",
    alt: "Priority",
  },
  stripe: {
    src: "/integrations/stripe.svg",
    alt: "Stripe",
  },
  morning: {
    src: "/integrations/morning.svg",
    alt: "Morning",
  },
} as const;

export type IntegrationLogoId = keyof typeof INTEGRATION_LOGOS;

export function IntegrationLogo({ id }: { id: IntegrationLogoId }) {
  const { src, alt } = INTEGRATION_LOGOS[id];

  return (
    <span className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-[10px] border border-slate-100 bg-white p-2">
      <img src={src} alt={alt} className="h-full w-full object-contain" />
    </span>
  );
}
